import React, { FC } from 'react'
import { SearchIcon, ChevronDownIcon, XIcon } from '@heroicons/react/outline'
import { LineInput, FilterGroup } from '../System'
import useIssueList from '../../redux/issue-list/useIssueList'
import { StyledIssueFilters } from '.'

const IssueFilters: FC = () => {
  // Array that populates the category filter bubbles
  const categoryFilters = ['sales', 'planning', 'engagement', 'captions']
  const {
    categories,
    search,
    platform,
    actions: { searchIssues, changePlatform, changeCategories }
  } = useIssueList()

  return (
    <StyledIssueFilters>
      <div className="page-header-top">
        <LineInput
          icon={<SearchIcon />}
          value={search}
          placeholder="Search Action Plans"
          clearInput={() => searchIssues('')}
          onChange={(value) => searchIssues(value)}
          debounce={500}
          className="page-header-search-input"
        />
        <label className="page-header-action dropdown">
          <select value={platform} onChange={(e) => changePlatform(e.target.value)}>
            <option defaultChecked value="">
              All Platforms
            </option>
            <option value="instagram">Instagram</option>
            <option value="facebook">Facebook</option>
            <option value="youtube">YouTube</option>
            <option value="linkedin">LinkedIn</option>
          </select>
          {!platform ? (
            <ChevronDownIcon />
          ) : (
            <XIcon className="clear-icon" onClick={() => changePlatform('')} />
          )}
        </label>
      </div>
      <div className="page-header-categories">
        <FilterGroup
          filters={categoryFilters}
          activeFilters={categories}
          onFilter={(filter) => changeCategories(filter)}
        />
      </div>
    </StyledIssueFilters>
  )
}

export default IssueFilters
